<template>
    <v-dialog v-model="dialog" width="600" scrollable>
        <v-card :disabled="load">
            <v-card-title class="pb-2">
                Editar ticket N° {{ ticket?.ticket_id || '' }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pt-6">
                <v-form ref="form">
                    <v-row>
                        <!-- 
                        prioridad
                        tipo
                        area
                        empresa
                        sucursal
                         -->
                        <v-col cols="11" sm="11" class="py-0">
                            <v-autocomplete v-model="data.tipo_ticket" label="Tipo" item-text="nombre"
                                item-value="tipo_id" :items="tipos_tickets" outlined dense clearable
                                hide-details></v-autocomplete>
                        </v-col>

                        <v-col cols="1"
                            style="display: flex; justify-content: center; position: relative; bottom: 16px; right: 10px;">
                            <v-btn icon @click="modalNuevoTipo = true" color="success">
                                <v-icon>fas fa-plus</v-icon>
                            </v-btn>
                        </v-col>

                        <v-col cols="6" sm="6" class="py-0">
                            <v-autocomplete v-model="data.prioridad" label="Prioridad" item-text="nombre"
                                item-value="prioridad_id" :items="prioridades" outlined dense
                                clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="6" class="py-0">
                            <v-autocomplete v-model="data.origen" label="Origen" item-text="nombre"
                                item-value="origen_id" :items="origenes" outlined dense clearable></v-autocomplete>
                        </v-col>

                        <v-col cols="6" sm="6" class="py-0">
                            <v-autocomplete v-model="data.area" label="Area" item-text="nombre" item-value="area_id"
                                :items="areas" outlined dense clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="6" xl="6" class="py-0">
                            <v-autocomplete v-model="data.empresa" label="Empresa" item-text="nombre" item-value="id"
                                tabindex="1" :items="empresas" hide-details clearable outlined dense
                                @change="setSucursal"></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="6" xl="6" class="py-0">
                            <v-autocomplete v-model="data.sucursal" item-text="provincia" label="Sucursal"
                                item-value="id" tabindex="1"
                                :items="sucursales.filter(suc => suc.familia_id === data?.empresa)" hide-details
                                clearable outlined dense></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-end pb-4">
                <v-btn color="error" class="mr-3" :disabled="load" @click="dialog = false">
                    Cancelar
                </v-btn>
                <BtnConfirmar :loading="load" @action="guardar()" />
            </v-card-actions>
        </v-card>
        <NuevoTipo v-model="modalNuevoTipo" @actualizarTipo="actualizarNuevoTipo($event)" />
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import BtnConfirmar from '../util/BtnConfirmar.vue';
import NuevoTipo from './NuevoTipo.vue';

export default {
    data() {
        return {
            load: false,
            local: null,
            modalNuevoTipo: false,
            data: {
                empresa: null,
                sucursal: null,
                tipo_ticket: null,
                area: null,
                prioridad: null,
                origen: null
            },
        }
    },

    props: {
        value: Boolean,
        empresas: {
            type: Array,
            default: []
        },

        prioridades: {
            type: Array,
            default: []
        },

        tipos_tickets: {
            type: Array,
            default: []
        },

        areas: {
            type: Array,
            default: []
        },

        origenes: {
            type: Array,
            default: []
        },

        ticket: {
            type: Object,
            default: {}
        }
    },

    async created() {

    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        ...mapState('genericos', ['sucursales'])
    },
    components: {
        BtnConfirmar,
        NuevoTipo
    },
    watch: {
        dialog(val) {
            if (val) {
                this.data = {
                    empresa: this.ticket?.empresa_id,
                    sucursal: this.ticket?.sucursal_id,
                    tipo_ticket: this.ticket?.tipo_ticket_id,
                    area: this.ticket?.area_id,
                    prioridad: this.ticket?.prioridad_id,
                    origen: this.ticket?.origen_id
                }
            } else {
                this.data = {
                    empresa: null,
                    sucursal: null,
                    tipo_ticket: null,
                    area: null,
                    prioridad: null,
                    origen: null
                }
            }
        },
    },
    methods: {
        async guardar() {
            this.$store.state.loading = true
            await this.$store.dispatch('tickets/editarTicket', {
                ...this.data,
                ticket_id: this.ticket?.ticket_id
            }).then(async res => {
                if (res.exito) {
                    this.$emit('actualizarTicket', res.data)
                    this.dialog = false
                    await this.$swal.fire({
                        icon: 'success',
                        title: res.message,
                    })
                } else {
                    this.$store.dispatch('show_snackbar', {
                        text: res.message,
                        color: 'error'
                    })
                }
            }).catch(error => {
                this.$store.dispatch('show_snackbar', {
                    text: error.message,
                    color: 'error'
                })
            })
            this.$store.state.loading = false
        },

        setSucursal() {
            const sucursal = this.sucursales.filter(
                suc => suc.familia_id === this.data.empresa
            )
            sucursal.length === 1 ? (this.filtro.sucursal = sucursal[0].id) : null
        },

        actualizarNuevoTipo(nuevoTipo) {
            if (nuevoTipo) {
                this.tipos_tickets.push(nuevoTipo)
                this.data.tipo_ticket = nuevoTipo.tipo_id
            }

        },
        limpiar() {
            this.$refs.form.resetValidation()
        }
    },
}
</script>